import Vue from 'vue'
import Vuex from 'vuex'
import api from '../api/api'
import i18n from '../i18n/index'
import { handleTree } from '@/router/format'
Vue.use(Vuex)

const state = {
    lang: sessionStorage.getItem('lang') || 'en',
    routes: [],
    orRoute: [],
    navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,//路由 index 
    comIndex: sessionStorage.getItem('comIndex') ? sessionStorage.getItem('comIndex') : 0, // 当前页面下组件index
    routePath: sessionStorage.getItem('routePath') ? sessionStorage.getItem('routePath') : '', //当前路由
    dialogFormVisible:false,
    menuName:sessionStorage.getItem('menuName') ? sessionStorage.getItem('menuName') : '', //当前页面name
}
const mutations = {
    setInter: (state, val) => {
        state.lang = val;
        i18n.locale = val;
        sessionStorage.setItem('lang', val);
    },
    setOrRoute: (state, val) => {
        state.orRoute = val
    },
    setRoutes: (state, val) => {
        state.routes = val;
        // sessionStorage.setItem('routes', val);
    },
    setNavIndex: (state, val) => {
        state.navIndex = val
    },
    setComIndex: (state, val) => {
        sessionStorage.setItem('comIndex', val)
        state.comIndex = val
    },
    setRoutePath: (state, val) => {
        sessionStorage.setItem('routePath', val)
        state.routePath = val
    },
    setDialogFormVisible: (state, val) => {
        state.dialogFormVisible = val
    },
    setmenuName:(state,val) =>{
        state.menuName=val
    }
}
const actions = {
    getRoutes: async (context) => {
        let res = await api.getHome({ language: context.state.lang })
        context.commit('setOrRoute', res.data.data||[])
        let listItem = handleTree(res.data.data || [], "typeId", "parentId", "list")
        context.commit('setRoutes', listItem)
        return listItem
    }
}
const getters = {
    // getUserInfo: (state) => {
    //     return state.comIndex;
    // },
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})


// WEBPACK FOOTER //
// ./src/store/index.js